import React from 'react';
import SliderPage from '../components/SliderPage/SliderPage';
import CoinsTable from '../components/CoinsTable';

function HomePage() {
  return (
  <>
    <SliderPage/>
    <CoinsTable/>
  </>
  )
}

export default HomePage